"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatWorkingHours = formatWorkingHours;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function formatWorkingHours({ workingTimeFrom, workingTimeTo, timezone }) {
    const clientUtcOffset = (0, moment_timezone_1.default)().utcOffset();
    const addressOffset = (0, moment_timezone_1.default)().tz(timezone).utcOffset() || clientUtcOffset;
    const timeFrom = workingTimeFrom ? (0, moment_timezone_1.default)(workingTimeFrom).utcOffset(-addressOffset + clientUtcOffset) : null;
    const timeTo = workingTimeTo ? (0, moment_timezone_1.default)(workingTimeTo).utcOffset(-addressOffset + clientUtcOffset) : null;
    return { timeFrom, timeTo };
}
